import React, { useCallback, useEffect, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import { coin_velocity_sentiment_data } from "../../Services/apiRoutes";
import { updateDates } from "../../utils/DatePagination";
import { CircularProgress, Grid } from "@mui/material";
import BasicCard from "../../components/card";
import BasicModal from "../../components/Modal";
import { getCryptoLogoMap } from "../../utils/utility";
import CloseIcon from "@mui/icons-material/Close";


let coinSymbol = [];
const CoinVelocitySentimentTable = ({ coin, onClose }) => {
    const [positiveCards, setPositiveCards] = useState([]);
    const [negativeCards, setNegativeCards] = useState([]);
    const [loading, setLoading] = useState(true);
    const [iconURL, setIconURL] = useState({});

    const isFetched = useRef(false);

    const [cardDetails, setCardDetails] = useState({});
    const [open, setOpen] = useState(false);

    const onReadMore = (cardDetails) => {
        setCardDetails(cardDetails);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setCardDetails(false);
    };


    const fetchCuratedCards = async () => {
        try {
            const data = await coin_velocity_sentiment_data(coin);
            let positiveData = [...positiveCards, ...data.data.positive];
            let negativeData = [...negativeCards, ...data.data.negative];
            pushCoins([...data.data.positive, ...data.data.negative]);
            getCoinData();
            positiveData = positiveData.sort((a, b) => new Date(b.datetime) - new Date(a.datetime));
            negativeData = negativeData.sort((a, b) => new Date(b.datetime) - new Date(a.datetime));
            setPositiveCards(positiveData);
            setNegativeCards(negativeData);
        } catch (error) {
            console.log("in history curated", error);
        } finally {
            setLoading(false);
        }
    };

    function isMobile() {
        const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const minSize = 450;
        return screenWidth <= minSize;
    }

    const getCoinData = async () => {
        var result = await getCryptoLogoMap(coinSymbol);
        setIconURL(result);
        return result;
    };

    const pushCoins = (dataArray) => {
        dataArray.forEach((data) => {
            if (data.coins.length)
                data?.coins?.forEach((coin) => {
                    coinSymbol.push(coin);
                });
        });
    };

    useEffect(() => {
        if (!isFetched.current) {
            fetchCuratedCards();
            isFetched.current = true;
        }
    }, []);
    return (
        <div>
            <Box position="relative" maxWidth="900px" margin="20px auto">
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems={"center"}
                    sx={{
                        // backgroundColor: "red",
                        position: "relative",
                    }}
                >
                    <Typography sx={{ fontWeight: "bold", textAlign: "center", marginTop: "50px", marginBottom: "30px" }} variant="h4">
                        {coin} Sentiment Data
                    </Typography>
                    <CloseIcon
                        onClick={() => {
                            onClose();
                        }}
                        style={{
                            alignSelf: "flex-end",
                            position: "absolute",
                            right: "0px",
                            top: "45%",
                            fontSize: "30px",
                            cursor: "pointer",
                        }}
                    />
                </Box>
            </Box>


            <Box
                className="all-cards"
                sx={{
                    // height: "500px",
                    maxHeight: "800px",
                    // maxWidth: "1500px",
                    margin: isMobile ? "9px" : "0 auto",
                    overflow: "scroll",
                }}
            >
                <div
                    style={{
                        minHeight: "100px",
                        marginBottom: "40px",
                        display: "flex",
                    }}
                >



                    {open && <BasicModal open={open} handleClose={handleClose} cardDetails={cardDetails} />}
                    {loading ? (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                marginTop: "50px",
                                marginLeft: "auto",
                                marginRight: "auto",
                            }}
                        >
                            <CircularProgress />
                        </div>
                    ) : (
                        <Grid
                            container
                            // gap={isTablet?1:5}
                            // 
                            // columns={{sm: 5, md: 2}}
                            sx={{
                                justifyContent: "center",
                                marginTop: "20px",
                                gap: "2.5vw",
                                display: "flex",
                                // backgroundColor:"green",
                            }}
                            className="grid-container"
                        >
                            {/* left side cards */}
                            {/* sm={isTablet?5.8:1} md={4} */}
                            <Grid container alignContent="flex-start" gap="3vw" width="48.5%" maxWidth="500px">
                                {positiveCards.map((sentiment) => (
                                    <Grid
                                        key={sentiment?._id}
                                        item
                                        sx={{
                                            // minWidth: "100%",
                                            width: "100%",
                                            // backgroundColor:"blue",
                                            // width:isTablet?"100%":"auto",
                                        }}
                                    >
                                        <BasicCard positive category={sentiment.Category} icons={iconURL} title={sentiment.title} text={sentiment.text} curated={sentiment.curated} score={sentiment.weighted_average} channel={sentiment.channel} coins={sentiment.coins} handle={sentiment.handle} datetime={sentiment.datetime} onReadMore={onReadMore} />
                                    </Grid>
                                ))}
                            </Grid>
                            {/* right side cards */}
                            {/* sm={isTablet?5.8:1} md={4} */}
                            <Grid container alignContent="flex-start" gap="3vw" width="48.5%" maxWidth="500px">
                                {negativeCards.map((sentiment) => (
                                    <Grid
                                        key={sentiment._id}
                                        item
                                        sx={{
                                            // minWidth: "100%",
                                            width: "100%"
                                            // backgroundColor:"blue",

                                        }}
                                    >
                                        <BasicCard positive={false} category={sentiment.Category} icons={iconURL} title={sentiment.title} text={sentiment.text} curated={sentiment.curated} score={sentiment.weighted_average} channel={sentiment.channel} coins={sentiment.coins} handle={sentiment.handle} datetime={sentiment.datetime} onReadMore={onReadMore} />
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    )}
                    <div
                        style={{
                            // display:isTablet?"flex":"auto",
                            height: "100px",
                        }}
                        id="loadMore"
                    ></div>
                </div>
            </Box>
        </div>
    );
};

export default React.memo(CoinVelocitySentimentTable);
